import React, { Component } from "react";
import PropTypes from "prop-types";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so next render shows fallback UI.
    return { hasError: true, error: error.message };
  }

  componentDidCatch(error) {
    // Display fallback UI
    if (window?.DD_RUM) {
      window.DD_RUM.addError(error, {
        scope: "platform-content",
        team: this.props.team || "unknown",
      });
    }
    this.setState({ hasError: true, error: error.message });
  }

  render() {
    const { hasError, error } = this.state;

    if (!hasError || !error) {
      return this.props.children;
    }

    return (
      <div data-testid="content-failure-message">
        Sorry! Something went wrong. <br />
        Please try again in a little bit.
      </div>
    );
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

ErrorBoundary.displayName = "ErrorBoundary";
export default ErrorBoundary;
